/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_Applicable_External_Resources_HintInputs */

const en_admin_discounts_applicable_external_resources_hint = /** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the resources this discount applies to`)
};

const de_admin_discounts_applicable_external_resources_hint = /** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle die Ressourcen aus, für die dieser Rabatt gilt`)
};

const es_admin_discounts_applicable_external_resources_hint = /** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona los recursos a los que aplica este descuento`)
};

const fr_admin_discounts_applicable_external_resources_hint = /** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les ressources auxquelles cette remise s'applique`)
};

const nl_admin_discounts_applicable_external_resources_hint = /** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer de voorzieningen waarop deze korting van toepassing is`)
};

/** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */
const it_admin_discounts_applicable_external_resources_hint = en_admin_discounts_applicable_external_resources_hint;

/** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */
const pt_br2_admin_discounts_applicable_external_resources_hint = en_admin_discounts_applicable_external_resources_hint;

/** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */
const pl_admin_discounts_applicable_external_resources_hint = en_admin_discounts_applicable_external_resources_hint;

/** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */
const hu_admin_discounts_applicable_external_resources_hint = en_admin_discounts_applicable_external_resources_hint;

/** @type {(inputs: Admin_Discounts_Applicable_External_Resources_HintInputs) => LocalizedString} */
const ro_admin_discounts_applicable_external_resources_hint = en_admin_discounts_applicable_external_resources_hint;

/**
* | output |
* | --- |
* | "Select the resources this discount applies to" |
*
* @param {Admin_Discounts_Applicable_External_Resources_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_applicable_external_resources_hint = /** @type {((inputs?: Admin_Discounts_Applicable_External_Resources_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_Applicable_External_Resources_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "de") return de_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "es") return es_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "fr") return fr_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "nl") return nl_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "it") return it_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "pl") return pl_admin_discounts_applicable_external_resources_hint(inputs)
	if (locale === "hu") return hu_admin_discounts_applicable_external_resources_hint(inputs)
	return ro_admin_discounts_applicable_external_resources_hint(inputs)
});
export { admin_discounts_applicable_external_resources_hint as "admin.discounts.applicable_external_resources_hint" }